import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	createdLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createdLabel: {
		id: 'created-date.read.created-label',
		defaultMessage: 'Created',
		description: 'Label for created field',
	},
});
export default messages;
